export default function Loading({isLoading}) {
    return (
        <div className="loading" open={isLoading}>
            <div className="lds-dual-ring"></div>
        </div>
    );
}